<template src="./Index.html">
</template>

<script>


    export default {
        components: {},
        created() {
            this.getAll();
            this.$store.dispatch("lookups/getLookups");
        },
        computed: {
           types() {
                return this.$store.getters["lookups/getLookupByType"](this.$lookupTypes.HealthDiseaseTypes)
            },
            info() {
                return this.$store.state.health.health;
            },
            pageCount() {
                return Math.ceil(
                    this.$store.state.health.totalItems / this.filters.pageSize
                );
            },
        },
        data() {
            return {      
                
                dialog: false,
                dialogMessage: null,
                headers: [
                    {
                        text: "نوع البيانات الصحية",
                        value: "type",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "الاسم / الوصف",
                        value: "description",
                        sortable: false,
                        align: "start",
                    },
                    {
                        text: "الإجراءات",
                        value: "actions",
                        sortable: false,
                        align: "center",
                    },

                ],
                items: [
                    {
                        text: "ملف الموظف ",
                    },
                    {
                        text: "البيانات الصحية",
                    },
                ],
                totalItems: 0,
                subtitle:"البيانات الصحية",
                filters: {
                    page: 1,
                    pageSize: 10,
                    typeId: null,
                    description: null,
              
                },
             
            };
        },
        methods: {
     
            getAll(page) {
                this.filters.page = page || 1;
                this.$store.dispatch("health/getHealth", this.filters);
            },
       
              showDialog(item) {
               this.dialogMessage = item.description;
                this.dialog = true;
            },

            cancelDialog() {
                this.dialog = false;
                this.dialogMessage = null;
            },
            back() {
                this.view = 0;
                this.items = [
                    {
                         text: "ملف الموظف ",
                    },
                    {
                        text: "البيانات الصحية",
                    },
                ];
            },
           
        },
    };
</script>
